
const transferPartners = {
  1: [
    "Aeromexico",
    "Air Canada",
    "Air France",
    "All-Accor Live Limitless",
    "Avianca Lifemiles",
    "British Airways",
    "Cathay Pacific",
    "Choice Privileges",
    "Emirates",
    "Etihad Airways",
    "EVA Air",
    "Finnair",
    "Japan Airlines",
    "Jetblue", 
    "Preferred Hotels & Resorts",
    "Qantas",
    "Singapore Airlines",
    "TAP Air Portugal",
    "Turkish Airlines",
    "Virgin Red",
    "Wyndham Rewards",
  ], // Capital One Venture X
  2: ["Hilton"], // Amex Hilton Aspire
  3: [
    "Marriott",
  ], // Marriott Bonvoy Brilliant (Marriott points transfer to many airlines)
  4: [
    "Aer Lingus",
    "Aeromexico",
    "Air Canada",
    "Air France",
    "ANA Mileage Club",
    "Avianca Lifemiles",
    "British Airways",
    "Cathay Pacific",
    "Choice Privileges",
    "Delta",
    "Emirates",
    "Etihad Airways",
    "Hilton",
    "Iberia",
    "JetBlue",
    "Marriott",
    "Qantas",
    "Qatar Airways",
    "Singapore Airlines",
    "Virgin Atlantic",
  ], // AMEX Gold
  5: [
    "Aer Lingus",
    "Air Canada",
    "Air France",
    "British Airways",
    "Hyatt",
    "Iberia",
    "IHG",
    "JetBlue",
    "Marriott",
    "Singapore Airlines",
    "Southwest",
    "United",
    "Virgin Atlantic",
  ], // Chase Sapphire Preferred
  6: [
    "Aer Lingus",
    "Air Canada",
    "Air France",
    "British Airways",
    "Hyatt",
    "Iberia",
    "IHG",
    "JetBlue",
    "Marriott",
    "Singapore Airlines",
    "Southwest",
    "United",
    "Virgin Atlantic",
  ], // Chase Sapphire Reserve
  7: [], // Chase Amazon Prime (Cashback only)
  8: ["Southwest"], // Chase Southwest Priority
  9: ["Southwest"], // Chase Southwest Business
  10: [], // Bank of America Customized Cash (Cashback)
  11: [], // Fidelity Visa (Cashback)
  12: [], // Chase Freedom Flex (Cashback/UR points but no transfer without CSP/CSR, treat as none for now or maybe keep it simple)
  13: [
    "Aer Lingus",
    "All-Accor Live Limitless",
    "Air Canada",
    "Air France",
    "Alaska Airlines",
    "Avianca Lifemiles",
    "British Airways",
    "Cathay Pacific",
    "Etihad Airways",
    "Emirates",
    "Hawaiian Airlines",
    "Hilton",
    "Hyatt",
    "Iberia",
    "IHG",
    "Japan Airlines",
    "Marriott",
    "Qatar Airways",
    "Southwest",
    "TAP Air Portugal",
    "Turkish Airlines",
    "United",
    "Virgin Atlantic",
  ], // Bilt
  14: [
    "Aer Lingus",
    "Aeromexico",
    "Air Canada",
    "Air France",
    "ANA Mileage Club",
    "Avianca Lifemiles",
    "British Airways",
    "Cathay Pacific",
    "Choice Privileges",
    "Delta",
    "Emirates",
    "Etihad Airways",
    "Hilton",
    "Iberia",
    "JetBlue",
    "Marriott",
    "Qantas",
    "Qatar Airways",
    "Singapore Airlines",
    "Virgin Atlantic",
  ], // AMEX Platinum
};

// Categorized lists
const hotelPartners = [
  "All-Accor Live Limitless",
  "Choice Privileges",
  "Hilton",
  "Hyatt",
  "IHG",
  "Marriott",
  "Preferred Hotels & Resorts",
  "Wyndham Rewards",
];

const airlinePartners = [
  "Aer Lingus",
  "Aeromexico",
  "Air Canada",
  "Air France",
  "Alaska Airlines",
  "American Airlines",
  "ANA Mileage Club",
  "Avianca Lifemiles",
  "British Airways",
  "Cathay Pacific",
  "Delta",
  "Emirates",
  "Etihad Airways",
  "EVA Air",
  "Finnair",
  "Hawaiian Airlines",
  "Iberia",
  "Japan Airlines",
  "JetBlue",
  "Lufthansa",
  "Qantas",
  "Qatar Airways",
  "Singapore Airlines",
  "Southwest",
  "TAP Air Portugal",
  "Turkish Airlines",
  "United",
  "Virgin Atlantic",
  "Virgin Red",
];

const partnerDetails = {
  "Aer Lingus": {
    description: "Flagship carrier of Ireland, part of IAG. Main hub in Dublin (DUB). Excellent for flights between the US East Coast and Ireland/Europe. Uses Avios currency.",
    url: "https://www.aerlingus.com/aerclub/",
  },
  "Aeromexico": {
    description: "Mexico's flag carrier with its main hub in Mexico City (MEX). SkyTeam member. Extensive network within Mexico and to North/South America, Europe, and Asia.",
    url: "https://www.aeromexico.com/en-us/aeromexico-rewards",
  },
  "Air Canada": {
    description: "Canada's largest airline. Star Alliance member. Major hubs in Toronto (YYZ), Vancouver (YVR), and Montreal (YUL). Great for flights to Canada, Europe, and Asia. Aeroplan is highly valued for its partner award charts.",
    url: "https://www.aircanada.com/ca/en/aco/home/aeroplan.html",
  },
  "Air France": {
    description: "French flag carrier with main hub in Paris (CDG). SkyTeam member. Excellent availability for Trans-Atlantic flights to Europe and connections to Africa and Asia. Flying Blue Promo Rewards often offer discounted award tickets.",
    url: "https://www.flyingblue.us/en/home",
  },
  "Alaska Airlines": {
    description: "Major US carrier based in Seattle (SEA). Oneworld member. Strong network on the US West Coast and flights to Hawaii, Mexico, and Costa Rica. Known for valuable partner redemptions (e.g., Cathay Pacific, JAL).",
    url: "https://www.alaskaair.com/content/mileage-plan",
  },
  "All-Accor Live Limitless": {
    description: "European hospitality giant with 5,000+ hotels. Brands include: Raffles, Fairmont, Sofitel, SLS, Pullman, Swissôtel, Novotel, Mercure, and Ibis.",
    url: "https://all.accor.com/",
  },
  "American Airlines": {
    description: "Major US carrier with hubs in Dallas (DFW), Charlotte (CLT), Chicago (ORD), Miami (MIA), Phoenix (PHX), and Philadelphia (PHL). Oneworld member. Extensive domestic and international network.",
    url: "https://www.aa.com/i18n/aadvantage-program/aadvantage-program.jsp",
  },
  "ANA Mileage Club": {
    description: "All Nippon Airways (ANA) is Japan's largest airline. Star Alliance member. Hubs in Tokyo (NRT/HND). Known for exceptional service and favorable award chart for round-trip travel.",
    url: "https://www.ana.co.jp/en/us/amc/",
  },
  "Avianca Lifemiles": {
    description: "Colombia's flag carrier and Star Alliance member. Main hub in Bogota (BOG). LifeMiles are excellent for booking Star Alliance partner awards (like United or Lufthansa) without carrier-imposed fuel surcharges.",
    url: "https://www.lifemiles.com/",
  },
  "British Airways": {
    description: "UK flag carrier based in London Heathrow (LHR). Oneworld member. Distance-based award chart is great for short-haul flights in Europe, Asia, and within the US (via partners like American/Alaska).",
    url: "https://www.britishairways.com/en-us/executive-club",
  },
  "Cathay Pacific": {
    description: "Hong Kong based carrier. Oneworld member. Connects Asia, North America, Europe, and Oceania via Hong Kong (HKG). Known for premium cabin products.",
    url: "https://www.cathaypacific.com/cx/en_US/membership.html",
  },
  "Choice Privileges": {
    description: "7,000+ hotels ranging from budget to upscale. Brands include: Cambria, Ascend, Comfort Inn, Comfort Suites, Quality Inn, Sleep Inn, Clarion, MainStay Suites, and Econo Lodge.",
    url: "https://www.choicehotels.com/choice-privileges",
  },
  "Delta": {
    description: "Major US carrier. SkyTeam member. Hubs: Atlanta (ATL), Detroit (DTW), Minneapolis (MSP), Salt Lake City (SLC), Seattle (SEA), LA (LAX), NYC (JFK/LGA), Boston (BOS). Dynamic pricing for awards.",
    url: "https://www.delta.com/us/en/skymiles/program-resources/program-rules",
  },
  "Emirates": {
    description: "UAE flag carrier based in Dubai (DXB). Connects the world through the Middle East. Famous for luxury First Class suites.",
    url: "https://www.emirates.com/us/english/skywards/",
  },
  "Etihad Airways": {
    description: "UAE national airline based in Abu Dhabi (AUH). Known for high-quality service and The Residence/Apartment cabins.",
    url: "https://www.etihadguest.com/",
  },
  "EVA Air": {
    description: "Taiwanese carrier based in Taipei (TPE). Star Alliance member. Connects Asia, North America, Europe, and Oceania. Highly rated service.",
    url: "https://www.evaair.com/en-us/infinity-mileagelands/",
  },
  "Finnair": {
    description: "Flag carrier of Finland based in Helsinki (HEL). Oneworld member. Offers great connections between Europe and Asia via the short northern route. Now uses Avios currency.",
    url: "https://www.finnair.com/us-en/finnair-plus",
  },
  "Hawaiian Airlines": {
    description: "Based in Honolulu (HNL). Connects Hawaii with the US Mainland, Asia, and South Pacific. Offers inter-island flights.",
    url: "https://www.hawaiianairlines.com/hawaiianmiles2",
  },
  "Hilton": {
    description: "18 brands across 7,000+ properties. Brands include: Waldorf Astoria, LXR, Conrad, Hilton, Curio Collection, DoubleTree, Tapestry Collection, Embassy Suites, Hilton Garden Inn, Hampton, Tru, and Homewood Suites.",
    url: "https://www.hilton.com/en/hilton-honors/",
  },
  "Hyatt": {
    description: "Global hospitality company with 1,100+ hotels. Brands include: Park Hyatt, Miraval, Grand Hyatt, Alila, Andaz, The Unbound Collection, Hyatt Regency, Hyatt Place, Hyatt House, Thompson Hotels, and Caption.",
    url: "https://world.hyatt.com/",
  },
  "Iberia": {
    description: "Spain's flag carrier based in Madrid (MAD). Part of IAG and Oneworld member. Good for connections between Europe and Latin America, and off-peak awards to Madrid.",
    url: "https://www.iberia.com/us/iberiaplus/",
  },
  "IHG": {
    description: "17 brands with 6,000+ destinations. Brands include: Six Senses, Regent, InterContinental, Kimpton, Hotel Indigo, Crowne Plaza, Holiday Inn, Holiday Inn Express, Staybridge Suites, and Candlewood Suites.",
    url: "https://www.ihg.com/onerewards/content/us/en/home",
  },
  "Japan Airlines": {
    description: "Japan's flag carrier based in Tokyo (NRT/HND). Oneworld member. Known for excellent service and premium cabins. Connects Japan with the world.",
    url: "https://www.jal.co.jp/jp/en/jmb/",
  },
  "JetBlue": {
    description: "Major US carrier with focus cities in New York (JFK), Boston (BOS), Fort Lauderdale (FLL), Los Angeles (LAX), Orlando (MCO). Offers Mint premium service on transcon and trans-Atlantic routes.",
    url: "https://www.jetblue.com/trueblue",
  },
  "KLM": {
    description: "Flag carrier of the Netherlands based in Amsterdam (AMS). SkyTeam member. Works closely with Air France. Good for connections worldwide.",
    url: "https://www.flyingblue.us/en/home",
  },
  "Lufthansa": {
    description: "Germany's flag carrier. Star Alliance founding member. Hubs in Frankfurt (FRA) and Munich (MUC). Massive global network.",
    url: "https://www.miles-and-more.com/",
  },
  "Marriott": {
    description: "Largest hotel chain with 30+ brands and 8,000+ properties. Brands include: Ritz-Carlton, St. Regis, JW Marriott, W Hotels, The Luxury Collection, Sheraton, Marriott, Westin, Autograph Collection, Renaissance, Courtyard, Residence Inn, and AC Hotels.",
    url: "https://www.marriott.com/loyalty.mi",
  },
  "Preferred Hotels & Resorts": {
    description: "Represents more than 750 independent hotels, resorts, residences, and unique hotel groups across 85 countries.",
    url: "https://preferredhotels.com/iprefer",
  },
  "Qantas": {
    description: "Australia's flag carrier based in Sydney (SYD). Oneworld member. Connects Australia to the world. Distance-based award chart.",
    url: "https://www.qantas.com/us/en/frequent-flyer.html",
  },
  "Qatar Airways": {
    description: "State-owned flag carrier of Qatar based in Doha (DOH). Oneworld member. Famous for Qsuite business class. Connects Europe, Africa, Asia, and Americas via Doha.",
    url: "https://www.qatarairways.com/en/Privilege-Club.html",
  },
  "Singapore Airlines": {
    description: "Flag carrier of Singapore based in Changi (SIN). Star Alliance member. Renowned for world-class service. Connects Asia with Europe, North America, and Oceania.",
    url: "https://www.singaporeair.com/en_UK/us/ppsclub-krisflyer/",
  },
  "Southwest": {
    description: "Major US domestic carrier. Focus on point-to-point service. Two bags fly free. No change fees. Extensive domestic network plus Mexico, Central America, and Caribbean.",
    url: "https://www.southwest.com/rapidrewards/",
  },
  "TAP Air Portugal": {
    description: "Flag carrier of Portugal based in Lisbon (LIS). Star Alliance member. Good for connections between Europe, South America (Brazil), and Africa.",
    url: "https://www.flytap.com/en-us/miles-and-go",
  },
  "Turkish Airlines": {
    description: "Flag carrier of Turkey based in Istanbul (IST). Star Alliance member. Flies to more countries than any other airline. Excellent lounge in Istanbul.",
    url: "https://www.turkishairlines.com/en-int/miles-and-smiles/",
  },
  "United": {
    description: "Major US carrier. Star Alliance member. Hubs: Chicago (ORD), Denver (DEN), Houston (IAH), LA (LAX), Newark (EWR), San Francisco (SFO), Washington DC (IAD). Massive global network.",
    url: "https://www.united.com/en/us/mileageplus",
  },
  "Virgin Atlantic": {
    description: "UK carrier based in London (LHR). SkyTeam member. Strong Trans-Atlantic network. Partners with Delta and Air France/KLM.",
    url: "https://flywith.virginatlantic.com/us/en/flying-club.html",
  },
  "Virgin Red": {
    description: "Redemption portal for Virgin companies. Points can be used for Virgin Atlantic flights, Virgin Voyages cruises, and Virgin Hotels.",
    url: "https://www.virgin.com/virgin-red",
  },
  "Wyndham Rewards": {
    description: "9,000+ hotels worldwide. Brands include: Wyndham Grand, Dolce, Wyndham, Tryp, Esplendor, Dazzler, Trademark, La Quinta, Wingate, Wyndham Garden, AmericInn, Ramada, Baymont, Microtel, Days Inn, Super 8, Howard Johnson, and Travelodge.",
    url: "https://www.wyndhamhotels.com/wyndham-rewards",
  },
};

export { transferPartners, hotelPartners, airlinePartners, partnerDetails };
